import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const ComponentIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 21)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3.17 13.27A2.61 2.61 0 0 1 .5 10.7V3.05A2.61 2.61 0 0 1 3.17.5h14.66a2.61 2.61 0 0 1 2.67 2.55v7.67a2.48 2.48 0 0 1-.67 1.68" />
      <path d="m10.28 20.5-3.27-4.37a1.3 1.3 0 0 1-.05-1.5 1.3 1.3 0 0 1 1.87-.33l1.45 1.1V7.1a1.28 1.28 0 0 1 1.28-1.28 1.28 1.28 0 0 1 1.28 1.27v5.11l3.55.8a2.55 2.55 0 0 1 2 2.72l-.44 4.78z" />
    </SVG>
  );
};
